import { memo, useContext, useMemo } from 'react';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { AnimationContainer } from '@/sub-luca-plugin/compatible-components';
import { useDebounceFn } from '@/sub-luca-plugin/utils';
import { getTransformToTeacherParams } from '@/sub-luca-plugin/components/qa-render/helper';
import { QaRecordsContext } from '../../helper';
import { tCommon, getCurrentLanguage } from '@/sub-luca-plugin/i18n';
import './indes.scss';

interface IProps {
    teacherAnswerTime: number | null;
}

const GoToTeacherQa = ({ teacherAnswerTime }: IProps) => {
    const { getQaStoreByContext } = useContext(QaRecordsContext);
    const lang = getCurrentLanguage();

    const backgroundStyle = useMemo(
        () => ({
            background: `url('${tCommon.t(
                'goToTeacherQaBackgroundUrl',
                'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/f31f5_20240926145938.png'
            )}') center/cover`,
        }),
        [lang]
    );

    const { run } = useDebounceFn(
        () => {
            eventBusExample.publish('DialogueArea', {
                type: 'transformToTeacherQa',
                params: getTransformToTeacherParams(),
            });
        },
        { wait: 500 }
    );

    return (
        <AnimationContainer
            className="go-to-teacher-qa"
            type="enter_from_the_left"
            canExcuteAimation={getQaStoreByContext()?.qaConfig.canExcuteAimation}
            style={backgroundStyle}
        >
            <div className="go-to-teacher-qa__btn" onClick={run}>
                {tCommon.t('submitNow', '立即提交')}
            </div>
            {teacherAnswerTime !== null && (
                <div className="go-to-teacher-qa__tips">
                    {tCommon.translate({
                        key: 'subjectTeacherReplyTime',
                        fallback: `该科目老师预计在 ${teacherAnswerTime} 小时内回复`,
                        variables: { count: teacherAnswerTime },
                    })}
                </div>
            )}
        </AnimationContainer>
    );
};

export default memo(GoToTeacherQa);
